export enum AuthorityPart {
  REGISTER_PART_DUPLICATE = '1.8.13',
  REGISTER_PART_VIEW_PRICES = '1.8.12',
  REGISTER_PART_QUERY_PARTS = '1.8.10',
  REGISTER_PART_EDIT_PRODUCT_PRICES = '1.8.8',
  REGISTER_PART_EDIT_PRODUCT_STOCK = '1.8.7',
  REGISTER_PART_PRODUCT_REPORTS = '1.8.5',
  REGISTER_PART_EDIT = '1.8.4',
  REGISTER_PART_DELETE = '1.8.3',
  REGISTER_PART_ADD = '1.8.2',
  REGISTER_PART_VIEW = '1.8.1',
  REGISTER_PART_PARTS_REGISTRATION = '1.8',

  VIEW_PARTS_STOCKS = '10.1.4',
  VIEW_PARTS_LAST_PURCHASES = '10.1.3',
  VIEW_PARTS_COSTS = '10.1.2',
  VIEW_PARTS_CONSULTATION = '10.1.0',
  VIEW_PARTS_PRICES = '10.1.1',

  PART_REPLACEMENT_CREATE = '1.8.9',
  PART_REPLACEMENT_READ = '1.8.9',
  PART_REPLACEMENT_DELETE = '1.8.9',

  PART_APPLICATION_READ = '1.8.11',
  PART_APPLICATION_CREATE = '1.8.11',
  PART_APPLICATION_UPDATE = '1.8.11',
  PART_APPLICATION_DELETE = '1.8.11',
}
